'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import LeadSyncingEntityRecord from 'AdsUI/records/LeadSyncingEntityRecord';
import Actions from 'AdsUI/lib/Actions';
export default ((state = ImmutableMap({
  selected: ImmutableSet(),
  available: ImmutableSet()
}), action) => {
  const {
    type,
    payload = []
  } = action;

  switch (type) {
    case Actions.LEAD_SYNCING_SELECTED_FETCH_SUCCEEDED:
      state = state.set('selected', ImmutableSet(payload.map(LeadSyncingEntityRecord.fromSelectedEntity)));
      break;

    default:
      break;
  }

  return state;
});